import { OperationService } from "@/services";
import $thousandMask from "@/mixins/thousandMask";
import dayjs from "dayjs";
export default {
  name: "deposit",
  components: {},
  props: [],
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  data() {
    return {
      typeOfOrderStatus: null,
      orderData: {},
      loading: false,
      copyFlag: true
    };
  },
  computed: {},
  mounted() {
    this.getOrderData(this.$route.params.id);
  },
  methods: {
    getOrderData(id) {
      this.loading = true;
      OperationService.showOrder(id)
        .then(response => {
          this.typeOfOrderStatus = response.data.data.status;
          this.orderData = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createOrderTransactionId() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("orderProcessPage.txNumberCopied"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 3000);
      }
    }
  }
};
